/**
 * Arredondamento por moeda (port do modelo do `vendas-app` Flutter).
 *
 * Estratégia: arredondar valor para a menor unidade da moeda alvo,
 * eliminando resíduos sub-unitários originados de conversões multi-moeda
 * (ex.: 1299,9975 ou 1300,0031 com cotações ruins).
 *
 * Casas decimais por moeda:
 *  - PYG (Guarani): 0 casas (unidade mínima = 1 Gs).
 *  - USD/BRL/ARS:   2 casas (unidade mínima = 0,01).
 *
 * Referência do modelo de origem:
 *  - `vendas-app/lib/common/components/quotation_widget/quotation_generic_widget.dart`
 *    linhas 115-146 (validação de fechamento por arredondamento simples).
 *
 * Documento de plano:
 *  - `vendas-site/docs/ai/PLANO_PORT_TROCO_MOBILE_PARA_WEB.md` (Mudança 3).
 */
export type CodigoMoeda = 'PYG' | 'USD' | 'BRL' | 'ARS';

/**
 * Retorna `valor` arredondado para a menor unidade da `codigoMoeda` informada.
 *
 * Exemplos:
 *  - `arredondarParaMoeda(143000.4999, 'PYG')` → `143000`
 *  - `arredondarParaMoeda(143000.5,    'PYG')` → `143001`
 *  - `arredondarParaMoeda(150.005,     'BRL')` → `150.01`
 *  - `arredondarParaMoeda(99.994,      'USD')` → `99.99`
 */
export function arredondarParaMoeda(valor: number, codigoMoeda: CodigoMoeda): number {
  const casas = codigoMoeda === 'PYG' ? 0 : 2;
  const fator = Math.pow(10, casas);
  return Math.round(valor * fator) / fator;
}
